import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/editSchedule.css";
import config from "../config"; // Импортируем API_URL

const EditSchedule = ({ groupId, onClose }) => {
  const [selectedDay, setSelectedDay] = useState(null);
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(false);

  const weekdays = [
    { id: 1, name: "ПН" },
    { id: 2, name: "ВТ" },
    { id: 3, name: "СР" },
    { id: 4, name: "ЧТ" },
    { id: 5, name: "ПТ" },
    { id: 6, name: "СБ" },
  ];

  useEffect(() => {
    if (selectedDay !== null) {
      fetchSchedule();
    }
  }, [selectedDay]);

  const fetchSchedule = async () => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${config.API_URL}/schedule`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response.data.length > 0) {
        setSchedule(response.data);
      }
    } catch (error) {
      console.error("Ошибка загрузки расписания:", error);
    }
  };

  const handleChange = (id, field, value) => {
    setSchedule((prevSchedule) =>
      prevSchedule.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const handleDelete = async (id) => {
    if (!id) {
      console.error("Ошибка: ID пары не определен");
      return;
    }

    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(
        `${config.API_URL}/schedule/delete/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        setSchedule((prevSchedule) => prevSchedule.filter((entry) => entry.id !== id));
        console.log("Пара успешно удалена");
        alert("Расписание успешно удалено!");
      } else {
        console.error("Ошибка удаления пары:", response.data.error);
      }
    } catch (error) {
      console.error("Ошибка при удалении пары:", error);
    }
  };

  const handleSave = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${config.API_URL}/schedule/edit/${groupId}`,
        { schedule },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      alert("Расписание обновлено!");
      onClose();
    } catch (error) {
      console.error("Ошибка сохранения расписания:", error);
      alert("Ошибка при обновлении расписания!");
    }
  };

  return (
    <div className="edit-schedule">
      <h2 className="second-text">Редактировать расписание</h2>

      <div className="weekdays">
        {weekdays.map((day) => (
          <button
            key={day.id}
            className={`sliding-button day-btn ${selectedDay === day.id ? "active" : ""}`}
            onClick={() => setSelectedDay(day.id)}
          >
            {day.name}
          </button>
        ))}
      </div>

      {loading ? (
        <p>Загрузка...</p>
      ) : (
        selectedDay && (
          <div className="edit-schedule-list">
            {schedule
              .filter((entry) => entry.weekday === selectedDay)
              .map((entry) => (
                <div key={entry.id} className="edit-schedule-row">
                  <select
                    value={entry.is_even_week}
                    onChange={(e) => handleChange(entry.id, "is_even_week", e.target.value === "true")}
                  >
                    <option value="true">Числитель (чётная)</option>
                    <option value="false">Знаменатель (нечётная)</option>
                  </select>

                  <input type="number" value={entry.order} onChange={(e) => handleChange(entry.id, "order", e.target.value)} />
                  <input type="text" value={entry.subject} onChange={(e) => handleChange(entry.id, "subject", e.target.value)} />
                  <input type="text" value={entry.teacher} onChange={(e) => handleChange(entry.id, "teacher", e.target.value)} />
                  <input type="text" value={entry.classroom} onChange={(e) => handleChange(entry.id, "classroom", e.target.value)} />

                  <button className="sliding-button edit-schedule-delete-btn" onClick={() => handleDelete(entry.id)}>🗑</button>
                </div>
              ))}
            <button className="sliding-button edit-schedule-save-btn" onClick={handleSave}>💾 Сохранить</button>
          </div>
        )
      )}
    </div>
  );
};

export default EditSchedule;
